import actionTypes from '../actions/action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_MESSAGE_SUCCESS: {
      return { ...action.message };
    }
    case actionTypes.CLEAR_SELECTED_MESSAGE: {
      return {};
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/message/reducers/message-details.js